<ng-container *ngIf="loading">
  <div class="loading-bar">
    <tm1-progress-ring value="" min="0" max="1" size="regular"></tm1-progress-ring>
  </div>
</ng-container>

<div *ngIf="loadError" class="venues-error">
  <tm1-banner appearance="error">{{ loadError }}</tm1-banner>
</div>

<ng-container *ngIf="!loading && !loadError">
  <div class="venues-toolbar">
    <tm1-text-field
      ngDefaultControl
      appearance="outline"
      inputsize="regular"
      label="Filter venues"
      placeholder="Name, ID, timezone, continent, city, or parent"
      type="text"
      [(ngModel)]="filterText"
      name="venueFilter">
    </tm1-text-field>
    <div class="venues-summary">
      <tm1-typography type="body-s">
        {{ filteredRows.length }} of {{ rows.length }} venues
      </tm1-typography>
    </div>
    <tm1-button variant="solid" (click)="openAddVenue()" [disabled]="isAdding">
      Add venue
    </tm1-button>
  </div>

  <app-add-venue
    *ngIf="isAdding"
    [record]="record"
    (saved)="onVenueSaved()"
    (cancelled)="onVenueCancelled()">
  </app-add-venue>

  <tm1-empty-state
    *ngIf="!rows.length"
    variant="no-result"
    title="No venues found"
    subtitle="The venueListExtended record is empty.">
  </tm1-empty-state>

  <tm1-empty-state
    *ngIf="rows.length && !filteredRows.length"
    variant="no-result"
    title="No matches"
    subtitle="Try a different search term.">
  </tm1-empty-state>

  <div class="card-container" *ngIf="filteredRows.length">
    <tm1-card variant="shadow">
      <tm1-data-grid
        grid-template-columns="13% 19% 13% 12% 12% 1fr 1fr"
        class="tm1-data-grid"
        generate-header=""
        focus-column-index="0"
        focus-row-index="0">
        <tm1-data-grid-row class="tm1-data-grid-row" row-type="sticky-header">
          <tm1-data-grid-cell grid-column="1" cell-type="columnheader">Venue ID</tm1-data-grid-cell>
          <tm1-data-grid-cell grid-column="2" cell-type="columnheader">Name</tm1-data-grid-cell>
          <tm1-data-grid-cell grid-column="3" cell-type="columnheader">Timezone</tm1-data-grid-cell>
          <tm1-data-grid-cell grid-column="4" cell-type="columnheader">Continent</tm1-data-grid-cell>
          <tm1-data-grid-cell grid-column="5" cell-type="columnheader">City</tm1-data-grid-cell>
          <tm1-data-grid-cell grid-column="6" cell-type="columnheader">Context</tm1-data-grid-cell>
          <tm1-data-grid-cell grid-column="7" cell-type="columnheader">Parents</tm1-data-grid-cell>
        </tm1-data-grid-row>
        <tm1-data-grid-row *ngFor="let row of filteredRows" class="tm1-data-grid-row">
          <tm1-data-grid-cell grid-column="1">{{ row.id }}</tm1-data-grid-cell>
          <tm1-data-grid-cell grid-column="2">{{ row.name }}</tm1-data-grid-cell>
          <tm1-data-grid-cell grid-column="3">{{ row.timezone || '—' }}</tm1-data-grid-cell>
          <tm1-data-grid-cell grid-column="4">{{ row.Continent || '—' }}</tm1-data-grid-cell>
          <tm1-data-grid-cell grid-column="5">{{ row.City || '—' }}</tm1-data-grid-cell>
          <tm1-data-grid-cell grid-column="6">
            <span class="context-badges" *ngIf="row.context?.length; else noContext">
              <tm1-badge
                *ngFor="let c of row.context"
                appearance="accent"
                baseColor="success"
                circular="">
                {{ c }}
              </tm1-badge>
            </span>
            <ng-template #noContext>—</ng-template>
          </tm1-data-grid-cell>
          <tm1-data-grid-cell grid-column="7">
            <span class="context-badges" *ngIf="row.parents?.length">
              <tm1-badge
                *ngFor="let p of row.parents"
                appearance="accent"
                baseColor="info"
                circular="">
                {{ p }}
              </tm1-badge>
            </span>
          </tm1-data-grid-cell>
        </tm1-data-grid-row>
      </tm1-data-grid>
    </tm1-card>
  </div>
</ng-container>
